import { render, staticRenderFns } from "./Compramarca.vue?vue&type=template&id=f33e2748&"
import script from "./Compramarca.vue?vue&type=script&lang=js&"
export * from "./Compramarca.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports